import { render } from "./BarsIcon.vue?vue&type=template&id=4d597f3a"
import script from "./BarsIcon.vue?vue&type=script&lang=js"
export * from "./BarsIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__